export default __webpack_public_path__ + "assets/ba52500adba52aa4794ebdbe36c53ea2.svg";